(function () {
  'use strict';

  if (customElements.get('delivery-estimator') && customElements.get('international-delivery-estimator')) return;

  var DAY_MS = 86400000;
  var WEEKDAYS = [1, 2, 3, 4, 5];
  var EVERY_DAY = [0, 1, 2, 3, 4, 5, 6];

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function dateKey(date) {
    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());
  }

  function calendarDate(year, month, day) {
    return new Date(Date.UTC(year, month - 1, day, 12));
  }

  function addCalendarDays(date, count) {
    return new Date(date.getTime() + count * DAY_MS);
  }

  function sameDate(first, second) {
    return dateKey(first) === dateKey(second);
  }

  function ordinalSuffix(day) {
    var remainder100 = day % 100;
    if (remainder100 >= 11 && remainder100 <= 13) return 'th';
    if (day % 10 === 1) return 'st';
    if (day % 10 === 2) return 'nd';
    if (day % 10 === 3) return 'rd';
    return 'th';
  }

  function formatOrdinalDate(date, longFormat) {
    var weekday = new Intl.DateTimeFormat('en-GB', {
      weekday: longFormat ? 'long' : 'short',
      timeZone: 'UTC'
    }).format(date);
    var month = new Intl.DateTimeFormat('en-GB', {
      month: longFormat ? 'long' : 'short',
      timeZone: 'UTC'
    }).format(date);
    var day = date.getUTCDate();
    return weekday + ', ' + day + ordinalSuffix(day) + ' ' + month;
  }

  function nthWeekday(year, month, weekday, occurrence) {
    var first = calendarDate(year, month, 1);
    var offset = (weekday - first.getUTCDay() + 7) % 7;
    return addCalendarDays(first, offset + (occurrence - 1) * 7);
  }

  function lastWeekday(year, month, weekday) {
    var last = calendarDate(year, month + 1, 0);
    var offset = (last.getUTCDay() - weekday + 7) % 7;
    return addCalendarDays(last, -offset);
  }

  function easterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return calendarDate(year, month, day);
  }

  function addObservedHoliday(set, date) {
    set.add(dateKey(date));
    var day = date.getUTCDay();
    if (day === 6) set.add(dateKey(addCalendarDays(date, 2)));
    if (day === 0) set.add(dateKey(addCalendarDays(date, 1)));
  }

  function englandWalesBankHolidays(year) {
    var holidays = new Set();
    var easter = easterSunday(year);

    addObservedHoliday(holidays, calendarDate(year, 1, 1));
    holidays.add(dateKey(addCalendarDays(easter, -2)));
    holidays.add(dateKey(addCalendarDays(easter, 1)));
    holidays.add(dateKey(nthWeekday(year, 5, 1, 1)));
    holidays.add(dateKey(lastWeekday(year, 5, 1)));
    holidays.add(dateKey(lastWeekday(year, 8, 1)));

    var christmas = calendarDate(year, 12, 25);
    var boxingDay = calendarDate(year, 12, 26);
    holidays.add(dateKey(christmas));
    holidays.add(dateKey(boxingDay));

    if (christmas.getUTCDay() === 6) {
      holidays.add(dateKey(calendarDate(year, 12, 27)));
      holidays.add(dateKey(calendarDate(year, 12, 28)));
    } else if (christmas.getUTCDay() === 0) {
      holidays.add(dateKey(calendarDate(year, 12, 27)));
      holidays.add(dateKey(calendarDate(year, 12, 26)));
    } else if (boxingDay.getUTCDay() === 6) {
      holidays.add(dateKey(calendarDate(year, 12, 28)));
    } else if (boxingDay.getUTCDay() === 0) {
      holidays.add(dateKey(calendarDate(year, 12, 28)));
    }

    return holidays;
  }

  function parseTime(value) {
    if (!value || !/^\d{1,2}:\d{2}$/.test(value)) return null;
    var pieces = value.split(':');
    var hour = Number(pieces[0]);
    var minute = Number(pieces[1]);
    if (hour > 23 || minute > 59) return null;
    return hour * 60 + minute;
  }

  function parseMoney(value) {
    var number = Number.parseFloat(String(value || '').replace(/[^0-9.-]/g, ''));
    return Number.isFinite(number) ? Math.max(0, number) : 0;
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function setHTML(node, value) {
    if (node && node.innerHTML !== value) node.innerHTML = value;
  }

  function getTimeZoneNow(timeZone) {
    var now = new Date();
    var resolvedTimeZone = timeZone || 'Europe/London';
    var formatter;
    try {
      formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: resolvedTimeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      });
    } catch (error) {
      resolvedTimeZone = 'Europe/London';
      formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: resolvedTimeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      });
    }

    var values = {};
    formatter.formatToParts(now).forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });

    return {
      instant: now,
      date: calendarDate(values.year, values.month, values.day),
      minutes: values.hour * 60 + values.minute,
      timeZone: resolvedTimeZone
    };
  }

  function getTimingModel(model) {
    var models = {
      inpost: {
        dispatchDays: WEEKDAYS,
        deliveryDays: WEEKDAYS,
        handlingDays: 0,
        minDays: 2,
        maxDays: 5
      },
      next_weekday: {
        dispatchDays: WEEKDAYS,
        deliveryDays: WEEKDAYS,
        handlingDays: 0,
        minDays: 1,
        maxDays: 1
      },
      dpd: {
        dispatchDays: [1, 2, 3, 4, 5, 6],
        deliveryDays: [0, 2, 3, 4, 5, 6],
        handlingDays: 0,
        minDays: 1,
        maxDays: 1
      },
      daily: {
        dispatchDays: EVERY_DAY,
        deliveryDays: EVERY_DAY,
        handlingDays: 0,
        minDays: 1,
        maxDays: 2
      },
      standard: {
        dispatchDays: WEEKDAYS,
        deliveryDays: WEEKDAYS,
        handlingDays: 2,
        minDays: 3,
        maxDays: 5
      }
    };

    var aliases = {
      weekday_2_5: 'inpost',
      next_weekday: 'next_weekday',
      next_day_dpd: 'dpd',
      dpd_next_day: 'dpd',
      daily_1_2: 'daily',
      standard_3_5: 'standard'
    };

    return models[aliases[model] || model] || models.standard;
  }

  class DeliveryEstimator extends HTMLElement {
    connectedCallback() {
      if (this.isReady) return;
      this.isReady = true;
      this.timeZone = this.dataset.timeZone || 'Europe/London';
      this.currencySymbol = this.dataset.currencySymbol || '£';
      this.extraBlackouts = new Set(
        (this.dataset.blackoutDates || '')
          .split(/[\s,]+/)
          .map(function (value) { return value.trim(); })
          .filter(function (value) { return /^\d{4}-\d{2}-\d{2}$/.test(value); })
      );
      this.holidayCache = new Map();
      this.options = Array.from(this.querySelectorAll('[data-delivery-option]'));
      this.valueInput = this.querySelector('[data-order-value]');
      this.cartTotalCents = Number.parseInt(this.dataset.cartTotalCents, 10);
      if (this.valueInput && Number.isFinite(this.cartTotalCents)) {
        this.valueInput.value = (Math.max(0, this.cartTotalCents) / 100).toFixed(2);
      }
      this.selectedOption = this.options.find(function (option) {
        return option.classList.contains('is-selected');
      }) || this.options[0];

      this.onOptionClick = this.onOptionClick.bind(this);
      this.onValueInput = this.onValueInput.bind(this);

      this.options.forEach(function (option) {
        option.addEventListener('click', this.onOptionClick);
      }, this);

      if (this.valueInput) this.valueInput.addEventListener('input', this.onValueInput);

      this.render();
      this.clockTimer = window.setInterval(this.render.bind(this), 60000);
      this.setAttribute('data-estimator-ready', '');
    }

    disconnectedCallback() {
      if (this.clockTimer) window.clearInterval(this.clockTimer);
      this.options.forEach(function (option) {
        option.removeEventListener('click', this.onOptionClick);
      }, this);
      if (this.valueInput) this.valueInput.removeEventListener('input', this.onValueInput);
      this.isReady = false;
    }

    onOptionClick(event) {
      this.selectOption(event.currentTarget);
    }

    onValueInput() {
      this.renderPrices();
      this.renderSelectedResult();
    }

    selectOption(option) {
      if (!option || option === this.selectedOption) return;
      this.options.forEach(function (item) {
        var isSelected = item === option;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-pressed', String(isSelected));
      });
      this.selectedOption = option;
      this.renderSelectedResult();
    }

    getLondonNow() {
      var now = getTimeZoneNow(this.timeZone);
      this.timeZone = now.timeZone;
      return now;
    }

    getHolidays(year) {
      if (!this.holidayCache.has(year)) {
        var holidays = englandWalesBankHolidays(year);
        this.extraBlackouts.forEach(function (date) { holidays.add(date); });
        this.holidayCache.set(year, holidays);
      }
      return this.holidayCache.get(year);
    }

    isHoliday(date) {
      return this.getHolidays(date.getUTCFullYear()).has(dateKey(date));
    }

    isServiceDay(date, allowedDays) {
      return allowedDays.indexOf(date.getUTCDay()) !== -1 && !this.isHoliday(date);
    }

    nextAllowedDate(date, allowedDays, includeCurrent) {
      var candidate = includeCurrent ? date : addCalendarDays(date, 1);
      var safety = 0;
      while (!this.isServiceDay(candidate, allowedDays) && safety < 370) {
        candidate = addCalendarDays(candidate, 1);
        safety += 1;
      }
      return candidate;
    }

    addServiceDays(date, count, allowedDays) {
      var result = date;
      var remaining = count;
      while (remaining > 0) {
        result = this.nextAllowedDate(result, allowedDays, false);
        remaining -= 1;
      }
      return result;
    }

    getEstimate(option) {
      var now = this.getLondonNow();
      var model = getTimingModel(option.dataset.timingModel);
      var todayDay = now.date.getUTCDay();
      var isWeekend = todayDay === 0 || todayDay === 6;
      var cutoffValue = isWeekend ? option.dataset.cutoffWeekend : option.dataset.cutoffWeekday;
      var cutoffMinutes = parseTime(cutoffValue);
      var canDispatchToday = this.isServiceDay(now.date, model.dispatchDays);
      var cutoffPassed = cutoffMinutes !== null && now.minutes > cutoffMinutes;
      var dispatch = now.date;

      if (!canDispatchToday || cutoffPassed) {
        dispatch = this.nextAllowedDate(now.date, model.dispatchDays, false);
      }

      if (model.handlingDays > 0) {
        dispatch = this.addServiceDays(dispatch, model.handlingDays, model.dispatchDays);
      }

      return {
        now: now,
        model: model,
        dispatch: dispatch,
        earliest: this.addServiceDays(dispatch, model.minDays, model.deliveryDays),
        latest: this.addServiceDays(dispatch, model.maxDays, model.deliveryDays),
        canDispatchToday: canDispatchToday,
        cutoffPassed: cutoffPassed,
        cutoffMinutes: cutoffMinutes,
        cutoffValue: cutoffValue
      };
    }

    formatShortDate(date) {
      return formatOrdinalDate(date, false);
    }

    formatLongDate(date) {
      return formatOrdinalDate(date, true);
    }

    formatDateRange(estimate, longFormat) {
      var formatter = longFormat ? this.formatLongDate.bind(this) : this.formatShortDate.bind(this);
      if (sameDate(estimate.earliest, estimate.latest)) return formatter(estimate.earliest);
      return formatter(estimate.earliest) + ' – ' + formatter(estimate.latest);
    }

    formatMoney(value) {
      return this.currencySymbol + value.toFixed(2);
    }

    getBasketValue() {
      if (!this.valueInput || this.valueInput.value.trim() === '') return null;
      return parseMoney(this.valueInput.value);
    }

    getPrice(option) {
      var basePrice = parseMoney(option.dataset.price);
      var threshold = parseMoney(option.dataset.freeThreshold);
      var value = this.getBasketValue();
      var isFree = option.dataset.freeEnabled === 'true' && value !== null && value >= threshold;
      return {
        amount: isFree ? 0 : basePrice,
        label: isFree ? 'FREE' : this.formatMoney(basePrice),
        isFree: isFree,
        threshold: threshold
      };
    }

    formatRemaining(nowMinutes, cutoffMinutes) {
      var remaining = Math.max(0, cutoffMinutes - nowMinutes);
      var hours = Math.floor(remaining / 60);
      var minutes = remaining % 60;
      var parts = [];
      if (hours) parts.push(hours + (hours === 1 ? ' hr' : ' hrs'));
      if (minutes || !hours) parts.push(minutes + ' mins');
      return parts.join(' ');
    }

    renderClock() {
      var now = this.getLondonNow();
      var dateNode = this.querySelector('[data-current-date]');
      var timeNode = this.querySelector('[data-current-time]');
      var noteNode = this.querySelector('[data-current-note]');
      if (dateNode) {
        setText(dateNode, formatOrdinalDate(now.date, true));
      }
      if (timeNode) {
        setText(timeNode, new Intl.DateTimeFormat('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          timeZoneName: 'short',
          timeZone: this.timeZone
        }).format(now.instant));
      }
      if (noteNode) {
        if (this.isHoliday(now.date)) {
          var nextWorkingDay = this.nextAllowedDate(now.date, WEEKDAYS, false);
          setText(noteNode, 'Today is a bank holiday. No orders are fulfilled today; fulfilment resumes on ' + this.formatLongDate(nextWorkingDay) + '.');
        } else {
          setText(noteNode, 'Times are shown in UK local time and update automatically.');
        }
      }
    }

    renderPrices() {
      var basketValue = this.getBasketValue();
      var status = this.querySelector('[data-basket-status]');
      var freeThresholds = [];

      this.options.forEach(function (option) {
        var price = this.getPrice(option);
        var priceNode = option.querySelector('[data-card-price]');
        if (priceNode) {
          setText(priceNode, price.label);
          priceNode.classList.toggle('is-free', price.isFree);
        }
        if (option.dataset.freeEnabled === 'true') freeThresholds.push(price.threshold);
      }, this);

      if (!status) return;
      status.classList.remove('is-qualified');
      if (basketValue === null) {
        setText(status, 'Enter your cart value to see which services are free.');
        return;
      }

      var lowestThreshold = freeThresholds.length ? Math.min.apply(Math, freeThresholds) : null;
      if (lowestThreshold !== null && basketValue >= lowestThreshold) {
        var qualifiedNames = this.options
          .filter(function (option) {
            return option.dataset.freeEnabled === 'true' && basketValue >= parseMoney(option.dataset.freeThreshold);
          })
          .map(function (option) { return option.dataset.serviceName; });
        var serviceList = new Intl.ListFormat('en-GB', { style: 'long', type: 'conjunction' }).format(qualifiedNames);
        setText(status, 'Great — your cart qualifies for free ' + serviceList + '.');
        status.classList.add('is-qualified');
      } else if (lowestThreshold !== null) {
        setText(status, 'Add ' + this.formatMoney(lowestThreshold - basketValue) + ' to qualify for free delivery.');
      } else {
        setText(status, 'The prices below have been updated for your cart.');
      }
    }

    renderOptionEstimates() {
      this.options.forEach(function (option) {
        var estimate = this.getEstimate(option);
        var node = option.querySelector('[data-card-estimate]');
        if (node) setText(node, 'Likely ' + this.formatDateRange(estimate, false));
      }, this);
    }

    renderSelectedResult() {
      if (!this.selectedOption) return;
      var estimate = this.getEstimate(this.selectedOption);
      var price = this.getPrice(this.selectedOption);
      var dateNode = this.querySelector('[data-result-date]');
      var contextNode = this.querySelector('[data-result-context]');
      var priceNode = this.querySelector('[data-result-price]');
      var dispatchNode = this.querySelector('[data-result-dispatch]');
      var cutoffNode = this.querySelector('[data-result-cutoff]');
      var detailsNode = this.querySelector('[data-result-details]');
      var template = this.querySelector('[data-service-template="' + CSS.escape(this.selectedOption.dataset.serviceId) + '"]');

      if (dateNode) setText(dateNode, this.formatDateRange(estimate, true));
      if (priceNode) {
        setText(priceNode, price.label);
        priceNode.classList.toggle('is-free', price.isFree);
      }
      if (dispatchNode) {
        setText(dispatchNode, sameDate(estimate.dispatch, estimate.now.date)
          ? 'Today'
          : this.formatShortDate(estimate.dispatch));
      }

      if (cutoffNode) {
        var weekdayCutoff = this.selectedOption.dataset.cutoffWeekday;
        var weekendCutoff = this.selectedOption.dataset.cutoffWeekend;
        if (!weekdayCutoff && !weekendCutoff) {
          setText(cutoffNode, 'No fixed cut-off');
        } else if (weekendCutoff) {
          setText(cutoffNode, 'Weekdays ' + weekdayCutoff + ' · weekends ' + weekendCutoff);
        } else {
          setText(cutoffNode, weekdayCutoff + ' weekdays');
        }
      }

      if (contextNode) {
        if (this.isHoliday(estimate.now.date)) {
          setHTML(contextNode, 'Today is a <strong>bank holiday</strong>, so no orders are fulfilled today. Estimated dispatch is <strong>' + this.formatLongDate(estimate.dispatch) + '</strong>.');
        } else if (estimate.model.handlingDays > 0) {
          setHTML(contextNode, 'Includes <strong>' + estimate.model.handlingDays + ' working days for handling</strong> before the delivery aim begins.');
        } else if (estimate.canDispatchToday && !estimate.cutoffPassed && estimate.cutoffMinutes !== null) {
          setHTML(contextNode, 'Order within <strong>' + this.formatRemaining(estimate.now.minutes, estimate.cutoffMinutes) + '</strong> for estimated dispatch today.');
        } else if (estimate.cutoffPassed) {
          setHTML(contextNode, 'Today’s cut-off has passed. Next estimated dispatch is <strong>' + this.formatLongDate(estimate.dispatch) + '</strong>.');
        } else {
          setHTML(contextNode, 'Orders placed now are expected to dispatch on <strong>' + this.formatLongDate(estimate.dispatch) + '</strong>.');
        }
      }

      if (detailsNode && template && detailsNode.dataset.activeService !== this.selectedOption.dataset.serviceId) {
        detailsNode.innerHTML = template.innerHTML;
        detailsNode.dataset.activeService = this.selectedOption.dataset.serviceId;
      }
    }

    render() {
      this.renderClock();
      this.renderPrices();
      this.renderOptionEstimates();
      this.renderSelectedResult();
    }
  }

  class InternationalDeliveryEstimator extends HTMLElement {
    connectedCallback() {
      if (this.isReady) return;
      this.isReady = true;
      this.timeZone = this.dataset.timeZone || 'Europe/London';
      this.minDays = Math.max(1, Number.parseInt(this.dataset.minDays, 10) || 2);
      this.maxDays = Math.max(this.minDays, Number.parseInt(this.dataset.maxDays, 10) || 11);
      this.priceLabel = this.dataset.priceLabel || 'Calculated at checkout';
      this.extraBlackouts = new Set(
        (this.dataset.blackoutDates || '')
          .split(/[\s,]+/)
          .map(function (value) { return value.trim(); })
          .filter(function (value) { return /^\d{4}-\d{2}-\d{2}$/.test(value); })
      );
      this.holidayCache = new Map();
      this.countrySelect = this.querySelector('[data-country-select]');
      this.onCountryChange = this.render.bind(this);
      if (this.countrySelect) this.countrySelect.addEventListener('change', this.onCountryChange);
      this.render();
      this.clockTimer = window.setInterval(this.render.bind(this), 60000);
      this.setAttribute('data-estimator-ready', '');
    }

    disconnectedCallback() {
      if (this.clockTimer) window.clearInterval(this.clockTimer);
      if (this.countrySelect) this.countrySelect.removeEventListener('change', this.onCountryChange);
      this.isReady = false;
    }

    getHolidays(year) {
      if (!this.holidayCache.has(year)) {
        var holidays = englandWalesBankHolidays(year);
        this.extraBlackouts.forEach(function (date) { holidays.add(date); });
        this.holidayCache.set(year, holidays);
      }
      return this.holidayCache.get(year);
    }

    isBusinessDay(date) {
      return WEEKDAYS.indexOf(date.getUTCDay()) !== -1 && !this.getHolidays(date.getUTCFullYear()).has(dateKey(date));
    }

    nextBusinessDay(date, includeCurrent) {
      var candidate = includeCurrent ? date : addCalendarDays(date, 1);
      var safety = 0;
      while (!this.isBusinessDay(candidate) && safety < 370) {
        candidate = addCalendarDays(candidate, 1);
        safety += 1;
      }
      return candidate;
    }

    addBusinessDays(date, count) {
      var result = date;
      var remaining = count;
      while (remaining > 0) {
        result = this.nextBusinessDay(result, false);
        remaining -= 1;
      }
      return result;
    }

    getEstimate() {
      var now = getTimeZoneNow(this.timeZone);
      this.timeZone = now.timeZone;
      var start = this.nextBusinessDay(now.date, true);
      return {
        now: now,
        earliest: this.addBusinessDays(start, this.minDays),
        latest: this.addBusinessDays(start, this.maxDays)
      };
    }

    formatDateRange(estimate) {
      if (sameDate(estimate.earliest, estimate.latest)) return formatOrdinalDate(estimate.earliest, true);
      return formatOrdinalDate(estimate.earliest, true) + ' – ' + formatOrdinalDate(estimate.latest, true);
    }

    selectedCountry() {
      if (!this.countrySelect || !this.countrySelect.value) return null;
      var option = this.countrySelect.options[this.countrySelect.selectedIndex];
      return {
        name: option.value,
        region: option.dataset.region || 'other'
      };
    }

    renderClock(now) {
      var dateNode = this.querySelector('[data-current-date]');
      var timeNode = this.querySelector('[data-current-time]');
      var noteNode = this.querySelector('[data-current-note]');
      setText(dateNode, formatOrdinalDate(now.date, true));
      if (timeNode) {
        setText(timeNode, new Intl.DateTimeFormat('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          timeZoneName: 'short',
          timeZone: this.timeZone
        }).format(now.instant));
      }
      if (noteNode) {
        if (this.getHolidays(now.date.getUTCFullYear()).has(dateKey(now.date))) {
          var nextWorkingDay = this.nextBusinessDay(now.date, false);
          setText(noteNode, 'Today is a bank holiday. No orders are fulfilled today; estimates begin from ' + formatOrdinalDate(nextWorkingDay, true) + '.');
        } else {
          setText(noteNode, 'Dates use UK working days and update automatically.');
        }
      }
    }

    render() {
      var estimate = this.getEstimate();
      var country = this.selectedCountry();
      var dateNode = this.querySelector('[data-international-date]');
      var contextNode = this.querySelector('[data-international-context]');
      var countryNode = this.querySelector('[data-international-country]');
      var priceNode = this.querySelector('[data-international-price]');
      var dutyNode = this.querySelector('[data-international-duty]');
      var regionNode = this.querySelector('[data-international-region]');
      var result = this.querySelector('[data-international-result]');

      this.renderClock(estimate.now);
      setText(priceNode, this.priceLabel);

      if (!country) {
        setText(dateNode, 'Select your destination');
        setText(contextNode, 'Choose a country above to see an estimated delivery window from today.');
        setText(countryNode, 'Not selected');
        setText(regionNode, 'Choose a country');
        setText(dutyNode, 'Duty and tax guidance will appear here after you choose your destination.');
        if (result) result.classList.add('is-awaiting-country');
        return;
      }

      if (result) result.classList.remove('is-awaiting-country');
      setText(dateNode, this.formatDateRange(estimate));
      if (this.getHolidays(estimate.now.date.getUTCFullYear()).has(dateKey(estimate.now.date))) {
        setText(contextNode, 'Today is a bank holiday, so no orders are fulfilled today. The estimate for ' + country.name + ' starts from the next working day.');
      } else {
        setText(contextNode, 'Estimated for delivery to ' + country.name + ' when ordered today.');
      }
      setText(countryNode, country.name);

      if (country.region === 'ioss') {
        setText(regionNode, 'EU IOSS region');
        setHTML(dutyNode, 'For orders below <strong>€150 including shipping</strong>, applicable EU tax is handled through IOSS. Final duty and tax treatment is confirmed at checkout.');
      } else {
        setText(regionNode, 'International DDP region');
        setHTML(dutyNode, 'Available FedEx charges, duties and taxes are calculated from your address and displayed at checkout. Orders use the available duty-paid service for the destination.');
      }
    }
  }

  if (!customElements.get('delivery-estimator')) customElements.define('delivery-estimator', DeliveryEstimator);
  if (!customElements.get('international-delivery-estimator')) customElements.define('international-delivery-estimator', InternationalDeliveryEstimator);
})();
